import { render, staticRenderFns } from "./storeClose.vue?vue&type=template&id=2d62ab64&scoped=true"
import script from "./storeClose.vue?vue&type=script&lang=js"
export * from "./storeClose.vue?vue&type=script&lang=js"
import style0 from "./storeClose.vue?vue&type=style&index=0&id=2d62ab64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d62ab64",
  null
  
)

export default component.exports